
export const missions = [
  {
    name: "ACE",
    icon: "ACE-sm.png",
    type: "",
    status: 'future',
    description:
      "Advanced Composition Explorer (ACE or Explorer 71) is a NASA Explorer program satellite and space exploration mission to study matter comprising energetic particles from the solar wind, the interplanetary medium, and other sources.",
  },

  {
    status: 'past',
    name: "ACRIMSAT",
    icon: "ACRIMSAT-sm.png",
    type: "Space Exploration",
    description:
      "The Active Cavity Radiometer Irradiance Monitor Satellite, or ACRIMSAT was a satellite carrying the ACRIM-3 (Active Cavity Radiometer Irradiance Monitor 3) instrument. It was one of the 21 observational components of NASA's Earth Observing System program.",
  },

  {
    status: 'operative',
    name: "AIM",
    icon: "AIM-sm.png",
    type: "Atmosphere",
    description:
      "AIM's mission is to study the physical and chemical processes that give rise to these mysterious polar mesospheric clouds, or PMCs.",
  },

  {
    type: "Water Cycle",
    name: "Aqua",
    icon: "Aqua-sm.png",
    description:
      "Aqua, Latin for water, is a NASA Earth Science satellite mission named for the large amount of information that the mission is collecting about the Earth's water cycle.",
  },

  {
    name: "Aquarius",
    icon: "Aquarius-sm.png",
    type: "Climate",
    description:
      "NASA's Aquarius was the primary instrument on the SAC-D spacecraft. It consisted of three passive microwave radiometers to detect the surface ",
  },

  {
    name: "Aura",
    icon: "Aura-sm.png",
    type: "Ozone",
    description:
      "Aura is a NASA mission to study Earth's ozone, air quality, and climate and conduct research on the composition, chemistry, and dynamics of Earth's .",
  },

  {
    name: "BepiColumbo",
    icon: "BepiColombo-sm.png",
    type: "Space Exploration",
    description:
      "BepiColombo is a joint mission of the European Space Agency (ESA) and the Japan Aerospace Exploration Agency (JAXA) to the planet Mercury.[4] The mission comprises two satellites launched together: the Mercury Planetary Orbiter (MPO) and Mio (Mercury Magnetospheric Orbiter, MMO).",
  },

  {
    name: "Calipso",
    icon: "Calipso-sm.png",
    type: "Climate",
    description:
      "The CALIPSO satellite provides new insight into the role that clouds and atmospheric aerosols play in regulating Earth's weather, climate, and air quality.",
  },

  { name: "Chandra", icon: "chandrayaan1-sm.png", description: "", type: "" },

  {
    name: "Chandrayaan",
    icon: "chandrayaan1-sm.png",
    description: "Chandrayaan-1 was the first Indian lunar probe under the Chandrayaan program. It was launched by the Indian Space Research Organisation in October 2008, and operated until August 2009. The mission included a lunar orbiter and an impactor.",
    type: "Space Exploration",
  },

  { name: "Cindi cnofs", icon: "CINDI_CNOFS-sm.png", type: "" },
  { name: "Clementine", icon: "Clementine-sm.png", type: "" },
  { name: "CloudSat", icon: "CloudSat_0.png", type: "Atmosphere" },
  { name: "COBE", icon: "COBE-sm.png", type: "Hurricanes" },
  { name: "Curiosity", icon: "Curiosity-sm.png", type: "Sun and its Influence on Earth" },
  { name: "Curiosity", icon: "Curiosity-sm.png", type: "" },
  { name: "CYGNSS fleet", icon: "CYGNSS-Fleet-sm.png", type: "Hurricanes" },
  { name: "CYGNSS", icon: "CYGNSS-sm.png", type: "Hurricanes" },
  { name: "Dawn", icon: "Dawn-sm_0.png", type: "Weather" },
  { name: "DSCOVR", icon: "DSCOVR-sm.png", type: "Sun and its Influence on Earth" },
  { name: "Epoxi", icon: "Epoxi-sm.png", type: "Water Cycle" },
  { name: "ER-2 mission", icon: "ER-2-sm.png", type: "Water Cycle" },
  { name: "Euclid", icon: "Euclid-sm.png", type: "Climate" },

  { name: "Europa", icon: "Europa-sm.png", type: "Climate" },
  { name: "Exo Mars Orbiter", icon: "ExoMars_Orbiter-sm.png", type: "" },
  { name: "Exo Mars Rover", icon: "Exomars_Rover-sm.png", type: "" },
  { name: "FA 18", icon: "FA_18-sm.png", type: "Wildfires" },

  { name: "Fermi Glast", icon: "Fermi_GLAST-sm.png", type: "Wildfires" },

  { name: "GALEX", icon: "GALEX-sm.png", type: "Atmosphere" },
  { name: "Galileo", icon: "Galileo-sm_0.png", type: "" },
  { name: "GEMS", icon: "GEMS-sm.png", type: "" },
  { name: "Geotail", icon: "Geotail-sm.png", type: "Sun and its Influence on Earth" },
  { name: "Glory", icon: "Glory-sm_0.png", type: "Atmosphere" },
  { name: "GOES R", icon: "GOES_R-sm.png", type: "Water Cycle" },
  { name: "GPM", icon: "GPM-sm.png", type: "Space Exploration" },
  { name: "Gulf Stream ", icon: "Gulf_Stream-sm.png", type: "" },
  { name: "Herschel", icon: "Herschel-sm.png", type: "" },
  { name: "HETE", icon: "HETE_1_2-sm.png", type: "" },
  { name: "Hinode", icon: "Hinode-sm.png", type: "Sun and its Influence on Earth" },
  { name: "Hitomi Astro H", icon: "Hitomi_Astro-H-sm.png", type: "" },
];
     
export const categories = [
  "Water Cycle",
  "Weather",
  "Atmosphere",
  "Climate",
  "Wildfires",
  "Space Exploration",
  "Sun and its Influence on Earth",
  "Ozone",
  "Hurricanes"
];